/* eslint-disable import/no-extraneous-dependencies */
import { lazy } from 'react';
import {
  APP_INVITATION_PATH,
  CAPACITY_MANAGEMENT_PARTNER_PICKER_PATH,
  CASE_MANAGEMENT_PATH,
  FAQ_PAGE_PATH,
  FORECAST_PATH,
  GET_STARTED_PATH,
  LANDING_PAGE,
  MANAGE_USERS_PAGE,
  NPC_PATH,
  PAM_PATH,
  PARTNER_PICKER_PATH,
  PICKER_PATH,
  PRIVACY_POLICY_PATH,
  PROFILE_PAGE,
  REPORTS_SHARING_PATH,
  TERMS_PATH,
  PERFORMANCE_INSIGHTS_PATH,
  PERFORMANCE_DASHBOARD_PATH,
  CSAT_SURVEY_PATH,
  RUBIKS_PATH,
  CMS_PATH,
} from './config/navigationalRoutes';
import LandingPageComponent from './pages/LandingPage';
import PrivacyPage from './pages/PrivacyPage';

// Lazy loaded modules/pages
const FaqPage = lazy(() => import('./pages/FaqPage'));
const GetStartedPage = lazy(() => import('./pages/GetStartedPage'));
const TermsAndConditionsPage = lazy(() => import('./pages/TermsAndConditionsPage'));
const ForecastComponent = lazy(() => import('@amzn/TransForecastUIAssets/dist/ForecastApp'));
const UserComponent = lazy(() => import('@amzn/PassportUserManagementUIAssets/dist/App'));
const LandingPage = lazy(() => import('@amzn/carrier-logistics-common-ui-assets/dist/App'));
const NPCManagementComponent = lazy(() => import('@amzn/passportweb-NPCManagementUIAssets/dist/App'));
const CapacityManagementComponent = lazy(() => import('@amzn/passportweb-transcapacitymanagementuiassets/dist/App'));
const PAMSelfServeUIComponent = lazy(() => import('@amzn/passportweb-PAMSelfServeUIAssets/dist/App'));
const CaseManagementComponent = lazy(() => import('@amzn/casemanagement-ui/dist/App'));
const CarrierPerformanceInsactComponent = lazy(() => import('@amzn/passportweb-CarrierPerformanceInsactUIAssets/dist/App'));
const TransReportsCenterUIComponent = lazy(() => import('@amzn/trans-reports-center-ui-assets/dist/App'));
const CarrierPerformanceDashboardComponent = lazy(() => import('@amzn/passportweb-carrierperformancedashboarduiassets/dist/App.external'));
const CSATSurvey = lazy(() => import('@amzn/TransCustomerFeedbackAggreatorServiceUIAssets/dist/App'));
const RubiksUIComponent = lazy(() => import('@amzn/passportweb-rubiksuiassets/dist/App.external'));
const CMSUIComponent = lazy(()=> import('@amzn/passportweb-CMSUIAssets/dist/App.external'));

const routeConfig = [
  {
    path: FAQ_PAGE_PATH,
    component: FaqPage,
    isLanguageToggleSupported: true,
  },
  {
    path: CMS_PATH,
    component: CMSUIComponent,
    isLanguageToggleSupported: false,
  },
  {
    path: GET_STARTED_PATH,
    component: GetStartedPage,
    isLanguageToggleSupported: true,
  },
  {
    path: TERMS_PATH,
    component: TermsAndConditionsPage,
    isLanguageToggleSupported: false,
    isLanguageToggleHidden: true,
  },
  {
    path: PRIVACY_POLICY_PATH,
    component: PrivacyPage,
    isLanguageToggleSupported: false,
    isLanguageToggleHidden: true,
  },
  {
    path: PROFILE_PAGE,
    component: UserComponent,
    isLanguageToggleSupported: true,
  },
  {
    path: FORECAST_PATH,
    component: ForecastComponent,
    isLanguageToggleSupported: true,
  },
  {
    path: CASE_MANAGEMENT_PATH,
    component: CaseManagementComponent,
    isLanguageToggleSupported: true,
  },
  {
    path: APP_INVITATION_PATH,
    component: UserComponent,
    isLanguageToggleSupported: true,
  },
  {
    path: PARTNER_PICKER_PATH,
    component: ForecastComponent,
    isLanguageToggleSupported: true,
  },
  {
    path: MANAGE_USERS_PAGE,
    component: UserComponent,
    isLanguageToggleSupported: true,
  },
  {
    path: LANDING_PAGE,
    component: LandingPageComponent,
    isLanguageToggleSupported: true,
  },
  {
    path: PICKER_PATH,
    component: LandingPage,
    isLanguageToggleSupported: true,
  },
  {
    path: NPC_PATH,
    component: NPCManagementComponent,
    isLanguageToggleSupported: true,
  },
  {
    path: CAPACITY_MANAGEMENT_PARTNER_PICKER_PATH,
    component: CapacityManagementComponent,
    isLanguageToggleSupported: true,
  },
  {
    path: PAM_PATH,
    component: PAMSelfServeUIComponent,
    isLanguageToggleSupported: true,
  },
  {
    path: PERFORMANCE_INSIGHTS_PATH,
    component: CarrierPerformanceInsactComponent,
    isLanguageToggleSupported: true,
  },
  {
    path: REPORTS_SHARING_PATH,
    component: TransReportsCenterUIComponent,
    isLanguageToggleSupported: false,
  },
  {
    path: PERFORMANCE_DASHBOARD_PATH,
    component: CarrierPerformanceDashboardComponent,
    isLanguageToggleSupported: true,
  },
  {
    path: CSAT_SURVEY_PATH,
    component: CSATSurvey,
    isLanguageToggleSupported: false,
  },
  {
    path: RUBIKS_PATH,
    component: RubiksUIComponent,
    isLanguageToggleSupported: true,
  },
];

export default routeConfig;
